var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg36File(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#0089FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0691 8.13477C20.527 8.1802 20.9577 8.38272 21.2859 8.71094L26.114 13.5391C26.489 13.9141 26.6999 14.4228 26.7 14.9531V25.375L26.6892 25.5791C26.5938 26.5207 25.8456 27.2688 24.9041 27.3643L24.7 27.375H12.45L12.2458 27.3643C11.2372 27.262 10.45 26.4107 10.45 25.375V10.125C10.45 9.08935 11.2372 8.238 12.2458 8.13574L12.45 8.125H19.8718L20.0691 8.13477ZM12.45 25.375H24.7V16.125H20.7C19.5955 16.125 18.7001 15.2295 18.7 14.125V10.125H12.45V25.375ZM20.7 14.125H23.8718L20.7 10.9531V14.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg36File);
export default __webpack_public_path__ + "static/media/36_File.832deced10e129ad3b0e2e9e1089bb4f.svg";
export { ForwardRef as ReactComponent };